import { Typography } from "@mui/material";
import PropTypes from "prop-types";
import { useState } from "react";
import AsiakasSelectorAutocomplete from "./AsiakasSelectorAutocomplete";
import MyModal from "src/components/layout/MyModal";
import { useUserData } from "src/context/userContext";

export default function AsiakasSelectorAutocompleteModal({
  isOpen = false,
  setIsOpen = () => {},
  onSelect = () => {},
  title = "Valitse asiakas",
  label = "Asiakas",
  defaultAsiakasId = 0,
}) {
  const { userAsiakas } = useUserData();

  const [selectedAsiakas, setSelectedAsiakas] = useState(null);

  const handleSetAsiakas = async (asiakas) => {
    setSelectedAsiakas(asiakas);
    onSelect(asiakas);
  };
  return (
    <MyModal
      enableCancel
      title={title}
      isOpen={isOpen}
      onClose={() => onSelect(selectedAsiakas)}
      onCancel={() => setIsOpen(false)}
      fullWidth={true}
      helpId=""
      saveButtonText="HYVÄKSY">
      <div style={{ paddingLeft: 16, paddingRight: 16 }}>
        <div className="spaceBetween" style={{ padding: "10px" }}>
          <Typography variant="body">{label}</Typography>
        </div>
        <AsiakasSelectorAutocomplete
          shrinkLabel={true}
          defaultAsiakasId={defaultAsiakasId}
          ownerAsiakasId={userAsiakas.asiakasId}
          label={label}
          variant="standard"
          setAsiakas={handleSetAsiakas}
          height={13}
        />
      </div>
    </MyModal>
  );
}

AsiakasSelectorAutocompleteModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  onSelect: PropTypes.func,
  title: PropTypes.string,
  defaultAsiakasId: PropTypes.number,
  label: PropTypes.string,
};
